var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTarget(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ff6464;}.b{fill:#fff;}.c{fill:#202029;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1070 -1488)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1070.049 1510.049)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 85,
    cy: 85,
    r: 85,
    transform: "translate(-0.049 -0.049)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 63.716,
    cy: 63.716,
    rx: 63.716,
    ry: 63.716,
    transform: "translate(21.236 21.236)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 42,
    cy: 42,
    r: 42,
    transform: "translate(42.951 42.951)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 21.236,
    cy: 21.236,
    rx: 21.236,
    ry: 21.236,
    transform: "translate(63.715 63.715)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1152 1488)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M388.414,53.713,389.78,38.69a6.287,6.287,0,0,1,1.816-3.877L410.418,15.99a3.144,3.144,0,0,1,4.446,0l11.272,11.272a3.144,3.144,0,0,1,0,4.446L407.313,50.531a6.287,6.287,0,0,1-3.876,1.816Z",
    transform: "translate(-322.423 -9.704)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M206.178,110a3.143,3.143,0,0,1-2.222-5.365L307.67.922a3.142,3.142,0,0,1,4.444,4.444L208.4,109.08A3.13,3.13,0,0,1,206.178,110Z",
    transform: "translate(-203.035 -0.001)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M492.359.986a3.362,3.362,0,0,0-4.756,0l-5.741,5.741,4.756,4.756,5.741-5.741A3.362,3.362,0,0,0,492.359.986Z",
    transform: "translate(-383.344 -0.001)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.61c1ed6cc178db29c44714d7980574ee.svg";
export { ForwardRef as ReactComponent };